import { createSlice } from "@reduxjs/toolkit";
import { updateEmployee } from "services/employee/employee";

const initialState = {
    employee : {
        data: [],
        isLoading: false,
        isSuccess: false,
        errorMessage: ''
    }
}
export const updateEmployeeSlice = createSlice({
    name: 'save employee',
    initialState,
    extraReducers: {
        [updateEmployee.pending]: (state) => {
            state.employee.isLoading = true;
        },
        [updateEmployee.fulfilled]: (state, { payload }) => {
            state.employee.isLoading = false;
            state.employee.isSuccess = true;
            state.employee.data = payload;
        },
        [updateEmployee.rejected]: (state, { payload }) => {
            state.employee.isLoading = false;
            state.employee.isSuccess = false;
            state.employee.errorMessage = payload
        }
    }
})
export default updateEmployeeSlice.reducer;